import React from 'react'

export default function ArtistProfilePage() {
    return (
        <div>ArtistProfilePage</div>
    )
}
